import { toast } from "react-toastify";
import { refreshAccessToken } from "./refreshAccessToken";
import { authStorage } from "../../utils/storage";

export const authFetch = async (
  url: string,
  options: RequestInit = {},
  silent = false,
): Promise<Response> => {
  const makeRequest = (token?: string) => {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers as Record<string, string>),
    };

    return fetch(url, { ...options, headers });
  };

  try {
    let token = authStorage.getAccessToken();
    let res = await makeRequest(token || undefined);

    if (res.status === 401) {
      const newToken = await refreshAccessToken();

      if (!newToken) {
        // 🔴 hard logout
        authStorage.clearTokens();

        window.location.href = "/signin";
        throw new Error("Unauthorized");
      }

      res = await makeRequest(newToken);
    }

    return res;
  } catch (err) {
    if (!silent) {
      toast.error("Network error. Please try again.");
    }
    throw err;
  }
};
